import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'faire_direct-enter_fd_widget_signup_flow-view';

/**
 * Retailer entering the signup flow from clicking on the FD widget
 */
export function trackFaireDirectEnterFdWidgetSignupFlowView(
  brandWidgetToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandWidgetToken },
  });
}
